/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionFlowFieldDto } from './SubscriptionFlowFieldDto';
import {
    SubscriptionFlowFieldDtoFromJSON,
    SubscriptionFlowFieldDtoFromJSONTyped,
    SubscriptionFlowFieldDtoToJSON,
    SubscriptionFlowFieldDtoToJSONTyped,
} from './SubscriptionFlowFieldDto';

/**
 * 
 * @export
 * @interface SubscriptionFlowConfigDto
 */
export interface SubscriptionFlowConfigDto {
    /**
     * 
     * @type {Array<SubscriptionFlowFieldDto>}
     * @memberof SubscriptionFlowConfigDto
     */
    stepStartChallenge: Array<SubscriptionFlowFieldDto> | null;
    /**
     * 
     * @type {Array<SubscriptionFlowFieldDto>}
     * @memberof SubscriptionFlowConfigDto
     */
    stepUserInfo: Array<SubscriptionFlowFieldDto>;
}

/**
 * Check if a given object implements the SubscriptionFlowConfigDto interface.
 */
export function instanceOfSubscriptionFlowConfigDto(value: object): value is SubscriptionFlowConfigDto {
    if (!('stepStartChallenge' in value) || value['stepStartChallenge'] === undefined) return false;
    if (!('stepUserInfo' in value) || value['stepUserInfo'] === undefined) return false;
    return true;
}

export function SubscriptionFlowConfigDtoFromJSON(json: any): SubscriptionFlowConfigDto {
    return SubscriptionFlowConfigDtoFromJSONTyped(json, false);
}

export function SubscriptionFlowConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionFlowConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'stepStartChallenge': (json['stepStartChallenge'] == null ? null : (json['stepStartChallenge'] as Array<any>).map(SubscriptionFlowFieldDtoFromJSON)),
        'stepUserInfo': ((json['stepUserInfo'] as Array<any>).map(SubscriptionFlowFieldDtoFromJSON)),
    };
}

export function SubscriptionFlowConfigDtoToJSON(json: any): SubscriptionFlowConfigDto {
    return SubscriptionFlowConfigDtoToJSONTyped(json, false);
}

export function SubscriptionFlowConfigDtoToJSONTyped(value?: SubscriptionFlowConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stepStartChallenge': (value['stepStartChallenge'] == null ? null : (value['stepStartChallenge'] as Array<any>).map(SubscriptionFlowFieldDtoToJSON)),
        'stepUserInfo': ((value['stepUserInfo'] as Array<any>).map(SubscriptionFlowFieldDtoToJSON)),
    };
}

